module.exports = __webpack_public_path__ + "media/content-creator/mobile-auto-2-5c95f2b0.png";